import { render, staticRenderFns } from "./DashboardMaster.vue?vue&type=template&id=44cd33c6&scoped=true"
import script from "./DashboardMaster.vue?vue&type=script&lang=js"
export * from "./DashboardMaster.vue?vue&type=script&lang=js"
import style0 from "./DashboardMaster.vue?vue&type=style&index=0&id=44cd33c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd33c6",
  null
  
)

export default component.exports